export default "https://static-website.miro.com/miro-site-lp-build-assets/_next/static/chunks/fonts/formular-light-c192bcc188223ebade68da0c65760edb.woff2";